import { css } from "@emotion/react";
import { Spacing } from "@snapchat/snap-design-system";

export const mainStyling = css`
    overflow: auto;
    height: 100%;
`;

export const controlContainerSmallDevice = css`
    padding-bottom: ${Spacing.SM}px;
    @media (max-width: 900px) {
        flex-direction: column;
    }
`;

export const inputStyling = css`
    flex-basis: 100px;
    margin: 0 0.5rem;

    @media (max-width: 900px) {
        flex-basis: unset;
        margin: 0.5rem 0;
    }
`;

export const dropdownStyling = css`
    margin: 1.5rem 10px;
`;

export const submitContainer = css`
    position: relative;
    @media (max-width: 900px) {
        position: relative;
        width: 100%;
        margin-top: 1rem;
    }
`;
export const submitStyling = css`
    position: absolute;
    bottom: 4px;

    @media (max-width: 900px) {
        position: relative !important;
        width: 100%;
    }
`;
